


import { Routes } from '@angular/router';
import { authGuard } from './services/auth-guard/auth.guard';
import { loginGuard } from './services/login-guard/login.guard';
import { adminGuard } from './services/admin-guard/admin.guard';

// Reports routes
const reportRoutes: Routes = [
  {
    path: '',
    redirectTo: 'summary',
    pathMatch: 'full',
  },
  {
    path: 'summary',
    loadComponent: () =>
      import('./pages/reports/report-summary/report-summary.component').then(m => m.ReportSummaryComponent),
    data: { breadcrumb: 'Report Summary', },
    canActivate: [authGuard],
  },
  {
    path: 'summary/case/:id',
    loadComponent: () =>
      import('./pages/reports/qc-form/qc-form.component').then(m => m.QcFormComponent),
    data: { breadcrumb: 'QC Form' },
    canActivate: [authGuard],
  },

  {
    path: 'all-reports',
    loadComponent: () =>
      import('./pages/reports/completed-reports/completed-reports.component').then(m => m.CompletedReportsComponent),
    data: { breadcrumb: 'All Reports' },
  },
  {
    path: 'all-reports/:id',
    loadComponent: () =>
      import('./pages/reports/qc-form/qc-form.component').then(m => m.QcFormComponent),
    data: { breadcrumb: 'QC Form' },
    canActivate: [authGuard],
  },
];


// Configuration routes
const configurationRoutes: Routes = [
  {
    path: 'license',
    loadComponent: () =>
      import('./pages/configuration/license-list/license-list.component').then(m => m.LicenseListComponent),
    data: { breadcrumb: 'License' },
  },
  {
    path: 'system-users',
    loadComponent: () =>
      import('./pages/configuration/system-users/system-users.component').then(m => m.SystemUsersComponent),
    data: { breadcrumb: 'System Users' },
  },
  {
    path: 'case-assignment',
    loadComponent: () =>
      import('./pages/configuration/case-assignment/case-assignment.component').then(m => m.CaseAssignmentComponent),
    data: { breadcrumb: 'Case Assignment' },
  },
  {
    path: 'reports-queue',
    loadComponent: () =>
      import('./pages/configuration/reports-queue/reports-queue.component').then(m => m.ReportsQueueComponent),
    data: { breadcrumb: 'Reports Queue' },
  },
  {
    path: '',
    redirectTo: 'system-users',
    pathMatch: 'full',
  },
  {
    path: 'test-master-data',
    loadComponent: () =>
      import('./pages/configuration/test-master-data/test-master-data.component').then(m => m.TestMasterDataComponent),
    data: { breadcrumb: 'Test Master Data' },
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./pages/configuration/app-settings/app-settings.component').then(m => m.AppSettingsComponent),
    data: { breadcrumb: 'Settings' },
  }
];

// Main routes
export const routes: Routes = [
  {
    path: 'sign-in',
    loadComponent: () =>
      import('./pages/auth/sign-in/sign-in.component').then(m => m.SignInComponent),
    data: { breadcrumb: 'Sign In' },
    canActivate: [loginGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./pages/auth/forot-password/forot-password.component').then(m => m.ForotPasswordComponent),
    data: { breadcrumb: 'Forgot Password' },
    canActivate: [loginGuard],
  },
  {
    path: 'license-expired',
    loadComponent: () => import('./pages/auth/license-expired/license-expired.component').then(m => m.LicenseExpiredComponent),
    data: { breadcrumb: 'License Expired' }
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./pages/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
    data: { breadcrumb: 'Reset Password' },
    canActivate: [authGuard],
  },
  {
    path: '',
    loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
        data: { breadcrumb: 'Dashboard' },
        canActivate: [authGuard],
      },
      {
        path: 'status-dashboard',
        loadComponent: () =>
          import('./pages/status-dashboard/status-dashboard.component').then(m => m.StatusDashboardComponent),
        data: { breadcrumb: 'Status Dashboard' },
        canActivate: [authGuard],
      },
      {
        path: 'reports',
        data: { breadcrumb: 'Reports' },
        canActivate: [authGuard],
        children: reportRoutes,
      },
      {
        path: 'configuration',
        data: { breadcrumb: 'Configuration' },
        canActivate: [authGuard, adminGuard],
        children: configurationRoutes,
      },
      {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },

];